module.exports = __webpack_public_path__ + "static/img/shiye_img6@2x.356ebac2.jpg";